import React from 'react';
import Header from './Header';
import Hakkimizda from './Hakkimizda';
import Etkinlikler from './Etkinlikler';
import YonetimKuruluTabs from "./YonetimKuruluV2";
import Contact from './Contact';
import PageTransition from './PageTransition';

const Home = ({ data }) => {
  return (
    <PageTransition>
      <Header data={data.main} />
      <Hakkimizda data={data.hakkimizda} />
      <Etkinlikler data={data} />
      <YonetimKuruluTabs data={data} />
      <Contact />
    </PageTransition>
  );
};

export default Home;
